import React from 'react';
import { urlStringForPathKey } from '@paddl/utils-js';
import { Button } from '../../Atoms/Button';
import { SignupPromoWrapper, TitleWrapper, SignupButton, ArtworkWrapper } from './SignupPromo.styles';
import { Artworks } from '../..';
export const SignupPromo = () => {
  const {
    womanOnLaptop: WomanOnLaptop
  } = Artworks;
  return /*#__PURE__*/React.createElement(SignupPromoWrapper, null, /*#__PURE__*/React.createElement(ArtworkWrapper, null, /*#__PURE__*/React.createElement(WomanOnLaptop, null)), /*#__PURE__*/React.createElement(TitleWrapper, null, "Discover, track and share your everyday learning with Paddl!"), /*#__PURE__*/React.createElement(SignupButton, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "blue",
    size: "medium",
    href: urlStringForPathKey('register')
  }, "Get started")));
};